export default __webpack_public_path__ + "static/media/luggage.7c722737.svg";